var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loaded)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):_vm._e(),(_vm.loaded)?_c('ImageComponent',{attrs:{"data":_vm.babybauch}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }